export default __webpack_public_path__ + "static/media/label-icon.69377006.svg";